import styles from './PageHeader.module.css';

/**
 * PageHeader
 * ──────────
 * Standard page-level heading used on every list page.
 *
 * @param {ReactNode} icon    Icon element (e.g. <FiArchive />)
 * @param {string}    title   Page title
 * @param {ReactNode} actions Right-side action buttons (e.g. "New Pledge" button)
 *
 * Usage:
 *   <PageHeader
 *     icon={<FiArchive />}
 *     title={NAV.pledges}
 *     actions={<button className="btn btn-primary btn-sm" onClick={openForm}>
 *       <FiPlus /> {ACTIONS.new(ENTITIES.pledge)}
 *     </button>}
 *   />
 */
export default function PageHeader({ icon, title, actions }) {
  return (
    <div className="page-header">
      <h2 className={styles.title}>
        {icon && <span className={styles.icon}>{icon}</span>}
        {title}
      </h2>
      {actions && <div className={styles.actions}>{actions}</div>}
    </div>
  );
}
